/* eslint-disable @typescript-eslint/no-explicit-any */
type PostMessageData = {
  type: string;
  [key: string]: unknown;
};

export const usePostMessageToReactNativeWebView = <T extends PostMessageData>() => {
  const postMessage = (data: T) => {
    const enhancedWindow: typeof window & { ReactNativeWebView?: { postMessage: (data: string) => void } } = window;

    if (enhancedWindow?.ReactNativeWebView) {
      enhancedWindow.ReactNativeWebView?.postMessage(JSON.stringify(data));
    }
  };

  return { postMessage };
};
